module.exports = __webpack_public_path__ + "img/logo-twolines-right-white-fr.dc8a28f0.png";